import { render } from "./BlockLinkEdit.vue?vue&type=template&id=3d64e848"
import script from "./BlockLinkEdit.vue?vue&type=script&lang=js"
export * from "./BlockLinkEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__